module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Jd.252d21f9.png";